import React from 'react';
import { User } from 'lucide-react';

export const PersonalDetails = ({ name, topic, onNameChange, onTopicChange }) => {
  return (
    <div className="w-full">
      <div className="flex items-center gap-3 mb-4 text-purple-400">
        <User className="w-5 h-5" />
        <h2 className="font-semibold">Personal Details</h2>
      </div>
      <div className="bg-gray-800/50 backdrop-blur-xl rounded-2xl p-6 border border-gray-700/50">
        <div className="flex gap-4 flex-col">
          <input
            type="text"
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
            placeholder="Enter your name"
            className="flex-1 px-4 py-3 bg-gray-900/50 border border-gray-700 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
          />
          <textarea 
            value={topic}
            onChange={(e) => onTopicChange(e.target.value)}
            placeholder="Enter a wellness topic (e.g., morning meditation)"
            className="flex-1 px-4 py-3 bg-gray-900/50 border border-gray-700 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
          />
        </div>
      </div>
    </div>
  );
};